module.exports = __webpack_public_path__ + "img/aqi_es.4274e785.jpg";